var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('Wrapper',{staticClass:"project spacer--padding--b--xl",attrs:{"size":{ s: 'm' }}},[_c('Gutenberg',{staticClass:"spacer--padding--x--m",attrs:{"data":_vm.post.gds_blocks}})],1),_c('Icon',{attrs:{"name":"close","to":"/","theme":"close-project"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }